import styles from './IconButton.module.scss';
import type { Size, Variant } from './interfaces';

export const VARIANT: Record<Variant, Variant> = {
  primary: 'primary',
  brand: 'brand',
  outlineBrand: 'outlineBrand',
  outline: 'outline',
  default: 'default',
  shadowS: 'shadowS',
  shadowXS: 'shadowXS',
  transparent: 'transparent',
  white: 'white',
};

export const SIZE: Record<Size, Size> = {
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
};

export const VariantMap = new Map<Variant, string | undefined>([
  [VARIANT.primary, styles.primary],
  [VARIANT.brand, styles.brand],
  [VARIANT.outline, styles.outline],
  [VARIANT.outlineBrand, styles.outlineBrand],
  [VARIANT.default, styles.default],
  [VARIANT.transparent, styles.transparent],
  [VARIANT.shadowS, styles.shadowS],
  [VARIANT.shadowXS, styles.shadowXS],
  [VARIANT.white, styles.white],
]);

export const SizeMap = new Map([
  [SIZE.XS, styles.sizeXS],
  [SIZE.S, styles.sizeS],
  [SIZE.M, styles.sizeM],
  [SIZE.L, styles.sizeL],
  [SIZE.XL, styles.sizeXL],
]);

export const IconSizeMap = new Map([
  [SIZE.XS, 16],
  [SIZE.S, 24],
  [SIZE.M, 24],
  [SIZE.L, 24],
  [SIZE.XL, 24],
]);
